import { FigmaIcon } from '../../../assets/icons/figma';
import { createEmbedProvider } from '../factory';

export const FIGMA_REGEX = /^https:\/\/(www\.)?figma\.com\/(design|file|proto|board)\/([a-zA-Z0-9]{22,128})(?:\/.*)?$/;

export const figmaProvider = createEmbedProvider({
  id: 'figma',
  label: 'Figma',
  icon: <FigmaIcon className="size-5" />,
  regex: FIGMA_REGEX,
  buildEmbedUrl: (match) => `https://www.figma.com/embed?embed_host=brainfish&url=${match[0]}`,
});
